import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { List } from 'immutable'

import { selectors as ThreadsSelectors } from 'data/threads'
import { record as ThreadsRecord } from 'data/threads'

import ThreadReplier from '../../Thread/ThreadReplier'
import CommentWrapper from '../CommentWrapper'
import Scrollable from 'components/Utils/Scrollable'
import ThreadHeader from './Header'
import Banner from '../Banner'
import { renderDate, getCommentsWithAfterBefore } from '../../utils'

class ThreadPanel extends Component {
  state = {
    scrolling: false,
  }

  static propTypes = {
    thread: PropTypes.instanceOf(ThreadsRecord),
    threadComments: PropTypes.instanceOf(List),
    activeThreadId: PropTypes.string,
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.thread &&
      nextProps.thread &&
      this.props.thread.id === nextProps.thread.id &&
      !this.props.thread.resolvedAt &&
      nextProps.thread.resolvedAt
    ) {
      //check if someone closed the thread while the user is watching it
      this.props.setDisplayClosedThreadBanner(true)
    }

    // Thread has been archived (received from a subscription)
    if (!nextProps.thread && this.props.thread) {
      this.props.goToMainPanelView()
    }
  }

  onScrollingStatusChange = scrolling => {
    this.setState({ scrolling })
  }

  render() {
    const {
      thread,
      activeThreadId,
      aknowledgedAt,
      setDisplayClosedThreadBanner,
      threadComments,
      noteId,
    } = this.props
    const firstComment = threadComments.first()
    const rows = getCommentsWithAfterBefore({
      comments: threadComments.rest(),
    })

    if (!thread || !threadComments.size) {
      return (
        <div className="margin-medium">
          The comment you're looking for could not be found, it has probably
          been deleted.
          <div
            className="font-weight-medium pointer margin-top-medium"
            onClick={() => this.props.goToMainPanelView()}
          >
            Go back
          </div>
        </div>
      )
    }
    let previousDate = firstComment.createdAt
    return (
      <div className="flexbox flexbox-column width-full height-full">
        <ThreadHeader
          goToMainPanelView={this.props.goToMainPanelView}
          threadId={this.props.activeThreadId}
          scrolling={this.state.scrolling}
          setDisplayClosedThreadBanner={setDisplayClosedThreadBanner}
        />
        <Banner
          show={this.props.showBanner}
          onCloseBanner={this.props.onCloseBanner}
        />
        <Scrollable
          bottomOnLoad
          innerClassName="flexbox flexbox-column flexbox-grow"
          onScrollingChange={this.onScrollingStatusChange}
          style={{
            height: 'calc(100vh - 62px)',
          }}
        >
          {renderDate(firstComment.createdAt, null)}

          {firstComment && (
            <div>
              <div>
                <CommentWrapper
                  firstComment
                  key={firstComment.id}
                  comment={firstComment}
                  highlight={thread.highlight}
                  aknowledgedAt={aknowledgedAt}
                  isResolved={!!thread.resolvedAt}
                  noteId={noteId}
                />
              </div>
              {threadComments.size > 1 && (
                <div
                  className="
                flexbox
                flexbox-align-center
                padding-bottom-medium
                padding-top-large
                padding-horizontal-large
                width-full"
                >
                  <hr className="width-full border-top-medium border-bottom-none border-left-none border-right-none border-shade-50" />
                  <span
                    className="
                    no-break-word
                    margin-horizontal-small
                    margin-horizontal-large
                    shade-20
                    font-weight-regular
                    center-text"
                  >
                    {threadComments.size - 1}{' '}
                    {threadComments.size === 2 ? 'reply' : 'replies'}
                  </span>
                  <hr className="width-full border-top-medium border-bottom-none border-left-none border-right-none border-shade-50" />
                </div>
              )}
            </div>
          )}
          {rows.map((row, index) => {
            const rowToRender = (
              <React.Fragment key={row.comment.id}>
                {renderDate(row.comment.createdAt, previousDate)}
                <CommentWrapper
                  index={index}
                  comment={row.comment}
                  sameAuthorBefore={row.sameAuthorBefore}
                  sameAuthorAfter={row.sameAuthorAfter}
                  aknowledgedAt={aknowledgedAt}
                  isResolved={!!thread.resolvedAt}
                  noteId={noteId}
                />
              </React.Fragment>
            )

            previousDate = row.comment.createdAt
            return rowToRender
          })}
          {!thread.resolvedAt && (
            <ThreadReplier
              // To fix the issue of selection when creating 2 comments in the row.
              // Should be fixed with the cleaning with Slate.
              threadId={activeThreadId}
              threadSubscriberIds={
                threadComments
                  .map(r => r.createdBy)
                  .toSet()
                  .toList() //filter duplicate
              }
            />
          )}
        </Scrollable>
      </div>
    )
  }
}

export default connect((state, { activeThreadId }) => {
  return {
    thread: ThreadsSelectors.getThread(state, activeThreadId),
    threadComments: ThreadsSelectors.getThreadComments(state, activeThreadId),
  }
})(ThreadPanel)
